import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _get from 'lodash/get';

import * as popupActions from '../../state/modules/popup';
import * as userActions from '../../state/modules/user/actions';
import { unusedBonusesSum } from '../../state/modules/user/selectors';
import {
  appStoreUrlSelector,
  playMarketUrlSelector,
  appGalleryUrlSelector,
} from '../../state/modules/city/selectors';

import NavBar from '../AuthModule/NavBar';
import Nav from '../Nav';
import MobilePhone from '../MobilePhone';
import MobileAppButton from '../MobileAppButton';
import LangSwitcher from '../LangSwitcher';
import AuthForms from '../AuthModule/Forms';
import Auth from './partials/Auth';

import styles from './MobileMenu.styl';

const cx = classNames.bind(styles);

class MobileMenu extends PureComponent {
  static propTypes = {
    phoneNumber: PropTypes.string.isRequired,
    popupAuth: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    showPopup: PropTypes.func.isRequired,
    hidePopup: PropTypes.func.isRequired,
    isTablet: PropTypes.bool,
  };

  authOnClick = () => {
    return this.props.showPopup('auth', { step: 'signIn' });
  };

  onClose = () => {
    if (this.props.popupAuth.isOpen) {
      return this.props.hidePopup('auth');
    }

    return this.props.onClose();
  };

  getMobileButton = () => {
    const { appleStoreUrl, playMarketUrl, OS, appGalleryUrl } = this.props;

    if (OS === 'iOS' && appleStoreUrl) {
      return <MobileAppButton className={cx('MobileMenu__app')} url={appleStoreUrl} type="apple" />;
    }

    if (OS === 'AndroidOS') {
      return (
        <>
          {playMarketUrl && (
            <MobileAppButton className={cx('MobileMenu__app')} url={playMarketUrl} type="google" />
          )}
          {appGalleryUrl && (
            <MobileAppButton className={cx('MobileMenu__app')} url={appGalleryUrl} type="huawei" />
          )}
        </>
      );
    }

    return null;
  };

  render() {
    const {
      popupAuth: { isOpen },
      phoneNumber,
      isTablet,
      ...otherProps
    } = this.props;

    return (
      <div className={cx('MobileMenu')}>
        <NavBar className={cx('MobileMenu__navbar')} isTablet={isTablet} onClose={this.onClose} />
        {isOpen ? (
          <div className={cx('MobileMenu__auth')}>
            <AuthForms />
          </div>
        ) : (
          <>
            <Auth {...otherProps} showForm={this.authOnClick} onClose={this.onClose} />
            <Nav className={cx('MobileMenu__nav')} onClose={this.onClose} />
            <div className={cx('MobileMenu__footer')}>
              {/*{phoneNumber && (*/}
              {/*  <MobilePhone className={cx('MobileMenu__phone')} phone={phoneNumber} />*/}
              {/*)}*/}
              {this.getMobileButton()}
              <LangSwitcher className={cx('MobileMenu__lang')} />
            </div>
          </>
        )}
      </div>
    );
  }
}

const connector = connect(
  state => ({
    phoneNumber: _get(state, 'city.userCity.help_number', ''),
    isAuthenticated: _get(state, 'user.isAuthenticated', false),
    profile: _get(state, 'user.profile', {}),
    bonuses: unusedBonusesSum(state),
    popupAuth: _get(state, 'popup.list.auth', {}),
    isPhone: _get(state, 'responsive.isPhone', false),
    appleStoreUrl: appStoreUrlSelector(state),
    playMarketUrl: playMarketUrlSelector(state),
    appGalleryUrl: appGalleryUrlSelector(state),
    OS: state.responsive.OS,
  }),
  dispatch =>
    bindActionCreators(
      {
        ...popupActions,
        ...userActions,
      },
      dispatch,
    ),
);

export default connector(MobileMenu);
